import { render } from "./SectionGeneral.vue?vue&type=template&id=1576079a&scoped=true"
import script from "./SectionGeneral.vue?vue&type=script&lang=js"
export * from "./SectionGeneral.vue?vue&type=script&lang=js"

import "./SectionGeneral.vue?vue&type=style&index=0&id=1576079a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1576079a"]])

export default __exports__